import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ContentWrapper = styled.div`
  margin-bottom: 80px;
  width: 100%;
  overflow-y: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 12px 12px 0 0;

  ${media.sm`
    bottom: 0;
  `}
`;

export const InfoWrapper = styled.div`
  padding: 48px 24px;
  font-size: 16px;
  ${media.sm`
    padding: 48px;
  `}
`;

export const GreyText = styled.div`
  color: #7c8183;
`;

export const RoomName = styled.h1`
  font-family: ${({ theme }) => theme.headerFont};
  color: ${({ theme }) => theme.sectionTitleColour};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-size: 28px;
  margin: 0 0;
`;

export const TitlePriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0 20px;

  ${media.md`
    padding: 12px 0 20px;
  `}
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
`;

export const ExtraAmount = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 18px;
  padding-bottom: 4px;
`;

export const ActualPrice = styled(GreyText)`
  font-size: 12px;
`;

export const Controls = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  display: flex;
  padding: 12px 24px 12px;
  flex-direction: row;
  background: white;
  box-shadow: 0px -5px 10px #00000029;
  transform: translate3d(0);
  justify-content: space-between;

  a {
    display: flex;
    flex-grow: 1;
  }

  a:first-child {
    margin-right: 4px;
  }

  a:last-child {
    margin-left: 4px;
  }

  ${media.sm`
    bottom: 0;
  `}

  ${media.md`
    padding: 24px 24px;
  `}
`;

export const AmenitiesList = styled.ul`
  padding-top: 10px;
  padding-left: 22px;
  li {
    padding: 2px 0;
  }
`;
